import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import CTSidebar from '../CTSidebar';
import { ProSidebarProvider } from 'react-pro-sidebar';
import PropTypes from 'prop-types';
import localSettingsManager from '../localSettings/localSettingsManager';
import * as settingConstants from '../constants/settingConstants';
import { useSelector } from 'react-redux';
import AuthUtil from './Utils/AuthUtil';
import { Backdrop, CircularProgress } from '@mui/material';
import UserApiService from '../api/UserApiService';

const Layout = (props) => {
    const [navMenuCollapsed, setNavMenuCollapsed] = useState(localSettingsManager.getSettingValue(settingConstants.navBarCollapsedSetting, false) === 'true');
    const { setSnackbarProperties, children } = props;
    function toggleNavMenu () {
        setNavMenuCollapsed(!navMenuCollapsed);
        localSettingsManager.setSettingValue(settingConstants.navBarCollapsedSetting, !navMenuCollapsed);
    }

    const userApiService = new UserApiService();

    const userToken = useSelector((state) => state.correcttrack.userToken);
    const isAuthorized = useMemo(() => AuthUtil.isAuthorized(userToken), [userToken]);
    const isPrintTaskPage = useMemo(() => window.location.href.includes('/PrintTask/'), [window.location.href]);
    const isTokenExpired = useMemo(() => AuthUtil.isTokenExpired(userToken), [userToken]);
    const showLayout = useMemo(() => !isAuthorized || (isAuthorized && !isTokenExpired), [isAuthorized, isTokenExpired]);

    useEffect(() => {
        if(isAuthorized && isTokenExpired) {
            userApiService.apiPing();
        }
    }, [isAuthorized, isTokenExpired]);

    return (
        <>
            {
                showLayout ?
                    (<div>
                    {isAuthorized && !isPrintTaskPage && <NavMenu toggleNavMenu={toggleNavMenu} setSnackbarProperties={setSnackbarProperties} />}
                    <div style={{display:'flex'}}>
                        {isAuthorized && !isPrintTaskPage && <ProSidebarProvider>
                            <CTSidebar navMenuCollapsed={navMenuCollapsed} />
                        </ProSidebarProvider> }
                        <div style={{ flex: 1 }}>
                            <Container tag={'main'}>
                                {children}
                            </Container>
                        </div>
                    </div>
                </div>)
                    :
                    (<Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={!showLayout}
                    >
                        <CircularProgress color='inherit' />
                    </Backdrop>)
            }
        </>

        );
};

Layout.propTypes = {
    children: PropTypes.object.isRequired,
};

export default Layout;
